//write interface for translations
export interface Translations {
	[key: string]: TranslationObject;
}

export interface TranslationObject {
	allAssetsText: string;
	assetsFilter: string;
	unconfiguredAssets: string;
	genericError: string;
}

export const translations: Translations = {
	de: {
		allAssetsText: "Alle sichtbaren Assets",
		assetsFilter: "Assets nach Name oder ID filtern",
		unconfiguredAssets:
			"Sie haben nicht konfigurierte Assets*. Standardmäßig erhalten Sie Benachrichtigungen von diesen Assets, es sei denn, Sie deaktivieren sie.",
		genericError: "An error occurred. Please try again later.",
	},
	zh: {
		allAssetsText: "所有可见的资产",
		assetsFilter: "按名称或 ID 筛选资产",
		unconfiguredAssets: "您有未配置的资产*。默认情况下，您将收到这些资产的通知，除非您将其禁用。",
		genericError: "An error occurred. Please try again later.",
	},
	en: {
		allAssetsText: "All visible assets",
		assetsFilter: "Filter assets by name or ID",
		unconfiguredAssets: "You have unconfigured assets*. By default, you will receive notifications from these assets unless you disable them.",
		genericError: "An error occurred. Please try again later.",
	},
	fr: {
		allAssetsText: "Tous les actifs visibles",
		assetsFilter: "Filtrer les actifs par nom ou ID",
		unconfiguredAssets:
			"Vous avez des ressources non configurées*. Par défaut, vous recevrez des notifications de ces ressources, sauf si vous les désactivez.",
		genericError: "An error occurred. Please try again later.",
	},
	it: {
		allAssetsText: "Tutte le asset visibili",
		assetsFilter: "Filtra gli asset per nome o ID",
		unconfiguredAssets: "Hai risorse non configurate*. Per impostazione predefinita, riceverai notifiche da queste risorse a meno che tu non le disattivi.",
		genericError: "An error occurred. Please try again later.",
	},
	ko: {
		allAssetsText: "모든 보이는 자산",
		assetsFilter: "이름 또는 ID로 자산 필터링",
		unconfiguredAssets: "구성되지 않은 자산이 있습니다*. 기본적으로 해당 자산에서 알림을 받게 되며, 비활성화하지 않으면 계속 수신됩니다.",
		genericError: "An error occurred. Please try again later.",
	},
	nl: {
		allAssetsText: "Alle zichtbare items",
		assetsFilter: "Assets filteren op naam of ID",
		unconfiguredAssets: "U heeft niet-geconfigureerde items*. Standaard ontvangt u meldingen van deze items, tenzij u ze uitschakelt.",
		genericError: "An error occurred. Please try again later.",
	},
	pl: {
		allAssetsText: "Wszystkie widoczne zasoby",
		assetsFilter: "Filtruj zasoby według nazwy lub ID",
		unconfiguredAssets: "Masz nie skonfigurowane zasoby*. Domyślnie będziesz otrzymywać powiadomienia z tych zasobów, chyba że je wyłączysz.",
		genericError: "An error occurred. Please try again later.",
	},
	es: {
		allAssetsText: "Todos los activos visibles",
		assetsFilter: "Filtrar activos por nombre o ID",
		unconfiguredAssets: "Tienes activos no configurados*. De forma predeterminada, recibirás notificaciones de estos activos a menos que los desactives.",
		genericError: "An error occurred. Please try again later.",
	},
	cs: {
		allAssetsText: "Všechny viditelné položky",
		assetsFilter: "Filtrovat aktiva podle názvu nebo ID",
		unconfiguredAssets: "Máte nekonfigurované položky*. Ve výchozím nastavení budete dostávat oznámení od těchto položek, pokud je nevypnete.",
		genericError: "An error occurred. Please try again later.",
	},
	hu: {
		allAssetsText: "Minden látható eszköz",
		assetsFilter: "Eszközök szűrése név vagy azonosító alapján",
		unconfiguredAssets: "Nem konfigurált eszközei vannak*. Alapértelmezés szerint értesítéseket fog kapni ezekről az eszközökről, hacsak nem tiltja le őket.",
		genericError: "An error occurred. Please try again later.",
	},
	zh_TW: {
		allAssetsText: "所有可見的資產",
		assetsFilter: "按名稱或 ID 篩選資產",
		unconfiguredAssets: "您有未設定的資產*。預設情況下，您將收到這些資產的通知，除非您將其停用。",
		genericError: "An error occurred. Please try again later.",
	},
	ja: {
		allAssetsText: "すべての表示中のアセット",
		assetsFilter: "名前またはIDで資産をフィルタリングする",
		unconfiguredAssets: "未設定のアセットがあります*。デフォルトでは、これらのアセットから通知を受け取りますが、無効化しない限り続きます。",
		genericError: "An error occurred. Please try again later.",
	},
	pt: {
		allAssetsText: "Todos os ativos visíveis",
		assetsFilter: "Filtrar ativos por nome ou ID",
		unconfiguredAssets: "Você tem ativos não configurados*. Por padrão, receberá notificações desses ativos, a menos que os desative.",
		genericError: "An error occurred. Please try again later.",
	},
};
